import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BannerComponent from "../components/vehiculos/banner.component";
import CategoriesComponent from "../components/vehiculos/categories.component";
import ContenidoComponent from "../components/vehiculos/contenido.component";
import { VehiclesAll } from "../components/conexion/vehicles.conexion";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";

/*eslint-disable */

const VehiculosPage: React.FC = () => {
  const [selectedCategories, setSelectedCategories] = useState("Todos");
  const [dataVehiculos, setDataVehiculos] = useState([]);
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [modelos, setModelos] = useState([
    {
      nombremodelo: "IONIQ 5 EV",
      nombrefamilia: "IONIQ 5",
      internal: "IONIQ 5",
      idmodelo: "a1YQC000000FK4s2AG",
      idfamilia: "a1FQC000007vHGE2A2",
    },
    {
      nombremodelo: "TUCSON 2.0L",
      nombrefamilia: "TUCSON",
      internal: "TUCSON",
      idmodelo: "a1YQC000000FL4A2AW",
      idfamilia: "a1FQC000007vHWM2A2",
    },
    {
      nombremodelo: "TUCSON 1.6T HEV",
      nombrefamilia: "TUCSON HIBRIDA",
      internal: "TUCSON Híbrida",
      idmodelo: "a1YQC000001AXN72AO",
      idfamilia: "a1FQC00000U0pFl2AJ",
    },
    {
      nombremodelo: "GRAND I10 1.2L",
      nombrefamilia: "GRAND I10",
      internal: "GRAND METRO SEDÁN",
      idmodelo: "a1YQC000000FKT42AO",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "GRAND I10 HB 1.2L",
      nombrefamilia: "GRAND I10",
      internal: "GRAND METRO HATCHBACK",
      idmodelo: "a1YQC0000010Fhd2AE",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "CRETA 1.5L",
      nombrefamilia: "CRETA",
      internal: "CRETA",
      idmodelo: "a1YQC000000FLTx2AO",
      idfamilia: "a1FQC000007vHuX2AU",
    },
    {
      nombremodelo: "HB20 1.6L",
      nombrefamilia: "HB20",
      internal: "HB20 Hatchback",
      idmodelo: "a1YQC000000FKrG2AW",
      idfamilia: "a1FQC000007vI7R2AU",
    },
    {
      nombremodelo: "HB20S 1.6L",
      nombrefamilia: "HB20S",
      internal: "HB20 Sedán",
      idmodelo: "a1YQC000000FLIf2AO",
      idfamilia: "a1FQC000007vI932AE",
    },
    {
      nombremodelo: "KONA 2.0L",
      nombrefamilia: "KONA",
      internal: "KONA Gasolina",
      idmodelo: "a1YQC000000FLtl2AG",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA 1.6L HEV",
      nombrefamilia: "KONA",
      internal: "KONA Híbrida",
      idmodelo: "a1YQC000000FLvN2AW",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA EV",
      nombrefamilia: "KONA",
      internal: "KONA Eléctrica",
      idmodelo: "a1YQC000000FM6f2AG",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA 1.6L HEV",
      nombrefamilia: "KONA",
      internal: "KONA Híbrida N Line",
      idmodelo: "a1YQC000000eQyH2AU",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "PALISADE 3.5L",
      nombrefamilia: "PALISADE",
      internal: "PALISADE",
      idmodelo: "a1YQC000000FM9t2AG",
      idfamilia: "a1FQC000007vIH72AM",
    },
    {
      nombremodelo: "STARIA 2.2L DIESEL",
      nombrefamilia: "STARIA",
      internal: "STARIA panel",
      idmodelo: "a1YQC000000FK9i2AG",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "STARIA 3.5L",
      nombrefamilia: "STARIA",
      internal: "STARIA lujo",
      idmodelo: "a1YQC000000FMD72AO",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "STARIA 2.2L DIESEL",
      nombrefamilia: "STARIA",
      internal: "STARIA pasajeros",
      idmodelo: "a1YQC000000FMEj2AO",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "VENUE 1.6L",
      nombrefamilia: "VENUE",
      internal: "VENUE",
      idmodelo: "a1YQC000000FMhl2AG",
      idfamilia: "a1FQC000007vILx2AM",
    },
    {
      nombremodelo: "SANTA FE 1.6T HEV",
      nombrefamilia: "SANTA FE Híbrida",
      internal: "SANTA FE",
      idmodelo: "a1YQC0000011VPN2A2",
      idfamilia: "a1FQC00000PcdoL2AR",
    },
  ]);
  useEffect(() => {
    // Accedemos directamente a la etiqueta body
    const bodyElement = document.body;

    // Añadir la clase deseada a body
    bodyElement.classList.remove("active"); //
    VehiclesAll().then(function (res: any) {
      let result: any = [];

      setDataVehiculos(res.data.data);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="vehiculo"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div className="home-page">
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Explora los Vehículos Hyundai en Colombia - Modelos y Tecnología
        </h1>

        <div className="home-page-mascara"></div>
        <BannerComponent />
        <CategoriesComponent
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
          categorias={dataVehiculos}
        />
        <ContenidoComponent
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
          vehiculos={dataVehiculos}
          modelos={modelos}
        />
        <div
          style={{ textAlign: "center", marginLeft: "5%", marginRight: "5%" }}
        >
          *Los valores y precios publicados son de referencia y pueden variar
          sin previo aviso.
        </div>
        <div
          style={{
            textAlign: "center",
            marginBottom: "40px",
            marginLeft: "5%",
            marginRight: "5%",
          }}
        >
          *Las imágenes son ilustrativas, algunas características de los
          vehículos de las imágenes pueden variar.
        </div>
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default VehiculosPage;
